(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-collection-slide"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var items = slideshow.querySelectorAll('.collection-slide__item');
    if (items.length <= 1) return;

    var dots = slideshow.querySelectorAll('[data-slide-dot]');
    var prevBtn = slideshow.querySelector('[data-slide-prev]');
    var nextBtn = slideshow.querySelector('[data-slide-next]');
    var current = 0;

    function goTo(index) {
      items[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');

      current = (index + items.length) % items.length;

      items[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
